import JournalEventModel from "core/models/journal-event";
import dayjs from "dayjs";

/**
 * return the last JE between 2 JEs
 * if 1 JE is null, return the other
 * if there are null, return undefined
 * @param {*} JE1
 * @param {*} JE2
 */
export default function mostRecentJe(JE1, JE2) {
  if (JE1 && JE2) {
    return dayjs(JE1.occurredAt).isAfter(dayjs(JE2.occurredAt)) ? JE1 : JE2;
  }
  return JE1 || JE2;
}